import axios from "axios";

let interceptorRegistered = false;

export function setupMaintenanceRedirectInterceptor() {
  if (interceptorRegistered) return;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 503 && typeof window !== "undefined") {
        const currentPath = window.location.pathname;
        if (currentPath !== "/maintenance") {
          window.location.href = "/maintenance";
        }
      }
      return Promise.reject(error);
    },
  );

  interceptorRegistered = true;
}
